import { render, staticRenderFns } from "./DefaultLoading.component.vue?vue&type=template&id=180e94ba"
import script from "./DefaultLoading.component.vue?vue&type=script&lang=js"
export * from "./DefaultLoading.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports